import { ICompanyCustomField } from "entities/Superuser/sdk";

export const extractCustomFieldPaths = ({
  data,
}: {
  data: Array<ICompanyCustomField>;
}) => {
  const result: Array<{ value: string; label: string; meta?: any }> = [];

  data.forEach((response) => {
    response.company_tabs.forEach((tab) => {
      tab.company_categories.forEach((category) => {
        category.company_sections.forEach((section) => {
          section.company_custom_fields.forEach((customField) => {
            const path = `${response.name} > ${tab.name} > ${category.name} > ${section.name} > ${customField.name}`;
            result.push({ value: customField.id.toString(), label: path });
          });
        });
      });
    });
  });

  return result;
};

export const extractIdToPathMapping = ({
  options,
}: {
  options: Array<{
    value: string;
    label: string;
    meta?: any;
  }>;
}) => {
  return options.reduce(
    (acc, option) => {
      acc[option.value] = option.label;
      return acc;
    },
    {} as { [key: string]: string }
  );
};
